import { GroupBySectionHeader } from '@monorepo/shared/componentsV2/aggregation/GroupBySectionHeader';
import {
  InfoCard,
  InfoCardVariant,
} from '@monorepo/shared/componentsV2/InfoCard';
import { AggregationGroupByList } from '@monorepo/workflowDataSetup/src/components/EditWorkflowStepsPage/EditAggregationStepModal/AggregationGroupByList';
import { WorkflowResponse } from 'mapistry-shared';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import {
  findStepInputDataset,
  findUpstreamVersionedDatasetNames,
} from '../stepUtils';
import { AggregationDefinitionList } from './AggregationDefinitionList';
import { AggregationInterval } from './AggregationInterval';

const StyledInfoCard = styled(InfoCard)`
  max-width: 32rem;
  margin-top: 0.5rem;
`;

interface EditAggregationStepFormProps {
  workflow: WorkflowResponse;
  stepId?: string;
}

export function EditAggregationStepForm({
  stepId,
  workflow,
}: EditAggregationStepFormProps) {
  const stepInputDataset = useMemo(
    () => findStepInputDataset(workflow, stepId),
    [stepId, workflow],
  );
  const upstreamVersionedDatasetNames = useMemo(
    () => findUpstreamVersionedDatasetNames(workflow, stepId),
    [stepId, workflow],
  );

  return (
    <>
      <AggregationInterval stepInputDataset={stepInputDataset} />

      <AggregationDefinitionList stepInputDataset={stepInputDataset} />

      <GroupBySectionHeader />
      <AggregationGroupByList stepInputDataset={stepInputDataset} />

      {stepInputDataset.isVersioned && (
        <StyledInfoCard variant={InfoCardVariant.WARNING}>
          <b>Are you sure you want to aggregate this data source?</b>
          <br />
          One or more of the fields in the{' '}
          <i>{upstreamVersionedDatasetNames.join(', ')}</i> has effective dates
          enabled. This means that a single Resource may contribute multiple
          values to your aggregation(s). This could lead to unexpected results.
          Consider adding a filter step to filter to only the latest version of
          the Resource before doing this aggregation. (Filters are currently
          only available in Reports.)
        </StyledInfoCard>
      )}
    </>
  );
}
